import { UserResponseBack } from './types';

export abstract class IUserHttpService {
  abstract getMe(): Promise<UserResponseBack>;
}
